import { render, staticRenderFns } from "./PictureMaskWindow.vue?vue&type=template&id=0287fe84&scoped=true&"
import script from "./PictureMaskWindow.vue?vue&type=script&scoped=true&lang=js&"
export * from "./PictureMaskWindow.vue?vue&type=script&scoped=true&lang=js&"
import style1 from "./PictureMaskWindow.vue?vue&type=style&index=1&id=0287fe84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../NodeModules/Ljbc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0287fe84",
  null
  
)

export default component.exports